// 채널 영상 해상도(video_resolution) wire 계약의 경계다.
//
// 구조 응답의 모든 채널에 이 필드가 있다. 이 파일은 아래 상태를 구분하려고 있다:
//   - null:          영상 채널이 아니다(벡터·parquet 채널).
//   - "measured":    파일들의 해상도가 하나로 모인다. resolutions 1개.
//   - "mixed":       해상도가 둘 이상 섞였다(통합 데이터셋 등). resolutions 2개 이상, 면적 큰 순.
//   - "unreadable":  mp4 헤더를 읽지 못했다. resolutions 빈 목록.
//   - "unmeasured":  아직 잰 파일이 없다. resolutions 빈 목록.
// BE 는 저장값 NULL 을 "unmeasured" 로 반환한다. 응답의 null 은 이미 "영상 채널 아님" 을 뜻한다.
//
// Owns:
// - `ChannelVideoResolution` wire 타입과 상태별 의미.
// - 표시용 해석(`displayVideoResolutions`). 모르는 두 상태를 하나로 합친다.
//
// Does not own:
// - 해상도를 측정하고 모으는 방법(BE 업로드 청크·요약 재계산).
// - 문구(`formatVideoResolutions`)와 표시할 화면(호출 컴포넌트).

// 영상의 가로×세로 픽셀이다.
export type VideoResolution = {
  width: number;
  height: number;
};

export type ChannelVideoResolutionStatus = "measured" | "mixed" | "unreadable" | "unmeasured";

// 한 영상 채널의 해상도 투영이다. 상태별 의미는 파일 첫 주석을 본다.
export type ChannelVideoResolution = {
  status: ChannelVideoResolutionStatus;
  resolutions: VideoResolution[];
};

/**
 * 채널 해상도를 표시할 해상도 목록으로 바꾼다.
 *
 * 읽기 실패와 미측정은 둘 다 빈 목록으로 합친다. 사용자에게는 둘 다 같은 "모름" 이다.
 * 이 값은 표시에만 쓴다. 두 상태를 구분해야 하면 이 결과를 쓰지 말고 status 를 본다.
 *
 * Args:
 *   value: 채널의 `video_resolution`. 예) `{ status: "mixed", resolutions: [{...}, {...}] }`
 *
 * Returns:
 *   영상 채널이 아니면 null, 해상도를 모르면 빈 목록, 알면 그 해상도들(면적 큰 순).
 */
export function displayVideoResolutions(
  value: ChannelVideoResolution | null,
): readonly VideoResolution[] | null {
  if (value === null) {
    return null;
  }
  if (value.status === "measured" || value.status === "mixed") {
    return value.resolutions;
  }
  return [];
}
